module.exports = __webpack_public_path__ + "c9486b98911ce7420884187767f6fa02.png";